import Axios from 'api/client';
import { Import, ImportDetails } from 'types/domain';
import { PaginatedData } from 'types/pagination';
import { FilterParams } from 'types/params';

interface FetchImportsParams extends FilterParams {
    drafts?: boolean;
    context?: string;
}

interface FetchImportDeletionStatsParams {
    type: Import['resource'];
    includeContacts?: boolean;
    includeTransactions?: boolean;
    deletionType: 'predelete' | 'postdelete';
}

interface DeleteImportParams {
    type: Import['resource'];
    includeContacts?: boolean;
    includeTransactions?: boolean;
}

interface FetchImportDeletionStatsResponse {
    data: {
        contacts: number;
        ignored_contacts: number;
        transactions: number;
        activities: number;
        soft_credits: number;
    };
}

const fetchImports = (accountId: number, params: FetchImportsParams) =>
    Axios.get<PaginatedData<Import>>(`/accounts/${accountId}/imports`, { params }).then(
        response => response.data,
    );

const fetchImport = (accountId: number, importId: number) =>
    Axios.get<ImportDetails>(`/accounts/${accountId}/imports/${importId}`).then(
        response => response.data,
    );

const fetchImportDeletionStats = (
    accountId: number,
    importId: number,
    params: FetchImportDeletionStatsParams,
) =>
    Axios.get<FetchImportDeletionStatsResponse>(
        `/accounts/${accountId}/imports/${importId}/deletion-stats`,
        {
            params,
        },
    ).then(response => response.data);

const deleteImport = (accountId: number, importId: number, params: DeleteImportParams) =>
    Axios.delete(`/accounts/${accountId}/imports/${importId}`, { data: params }).then(
        response => response.data,
    );

const deleteDraftImport = (accountId: number, importId: number) =>
    Axios.delete(`/accounts/${accountId}/import-drafts/${importId}`).then(
        response => response.data,
    );

export { fetchImports, fetchImport, fetchImportDeletionStats, deleteImport, deleteDraftImport };
export type { FetchImportDeletionStatsParams, FetchImportsParams };
